"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoTargetsResponseToJSON = exports.GeoTargetsResponseFromJSONTyped = exports.GeoTargetsResponseFromJSON = exports.instanceOfGeoTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var GeoTarget_1 = require("./GeoTarget");
/**
 * Check if a given object implements the GeoTargetsResponse interface.
 */
function instanceOfGeoTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGeoTargetsResponse = instanceOfGeoTargetsResponse;
function GeoTargetsResponseFromJSON(json) {
    return GeoTargetsResponseFromJSONTyped(json, false);
}
exports.GeoTargetsResponseFromJSON = GeoTargetsResponseFromJSON;
function GeoTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
        'pageSize': !(0, runtime_1.exists)(json, 'page_size') ? undefined : json['page_size'],
        'geos': !(0, runtime_1.exists)(json, 'geos') ? undefined : (json['geos'].map(GeoTarget_1.GeoTargetFromJSON)),
    };
}
exports.GeoTargetsResponseFromJSONTyped = GeoTargetsResponseFromJSONTyped;
function GeoTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'offset': value.offset,
        'page_size': value.pageSize,
        'geos': value.geos === undefined ? undefined : (value.geos.map(GeoTarget_1.GeoTargetToJSON)),
    };
}
exports.GeoTargetsResponseToJSON = GeoTargetsResponseToJSON;
